<p-dialog styleClass="preview-dialog"
          [style]="{minWidth: '550px'}"
          [closeOnEscape]="false"
          [closable]="false"
          header="{{title}}"
          [(visible)]="showDialog"
          [responsive]="true"
          showEffect="fade"
          [modal]="true"
          appendTo="body">

    <p>Please select from the dropdown a Supplier, Other type creditor or User's profile</p>
    <form [formGroup]="form">

      <div>
        <label for="previewBy">Select</label>
      </div>
      <div>
        <p-selectButton id="previewBy" name="previewBy" [options]="previewByOptions" formControlName="previewBy"></p-selectButton>
      </div>

      <ng-container [ngSwitch]="previewByValue">

        <p-dropdown *ngSwitchCase="'supplier'"
                    hideDropdownOnScroll
                    formControlName="selectedSupplier"
                    id="suppliers"
                    name="suppliers"
                    [filter]="true" filterBy="label,value.name"
                    [options]="suppliers"
                    appendTo="body"
                    placeholder="Select supplier..."
                    panelStyleClass="admin-form"
                    [style]="{'width': '100%'}">
        </p-dropdown>

        <p-dropdown *ngSwitchCase="'creditor'"
                    hideDropdownOnScroll
                    formControlName="selectedCreditor"
                    id="creditors"
                    name="creditors"
                    [filter]="true" filterBy="label,value.name"
                    [options]="creditors"
                    appendTo="body"
                    placeholder="Select creditor..."
                    panelStyleClass="admin-form"
                    [style]="{'width': '100%'}">
        </p-dropdown>

        <p-dropdown *ngSwitchCase="'user'"
                    hideDropdownOnScroll
                    formControlName="selectedUser"
                    id="users"
                    name="users"
                    [filter]="true" filterBy="label,value.name"
                    [options]="users"
                    appendTo="body"
                    placeholder="Select user..."
                    panelStyleClass="admin-form"
                    [style]="{'width': '100%'}">
        </p-dropdown>

      </ng-container>


    </form>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button type="button" pButton icon="fa-fw fa fa-close" (click)="cancelHandler()" label="Cancel"></button>
      <button type="button" [disabled]="!form.valid" pButton icon="fa-fw fa fa-check" (click)="okHandler()" label="Ok"></button>
    </div>
  </p-footer>

</p-dialog>
